
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import {currentUserModule, rolesModule, usersModule} from "@/store";
import {deepCopy} from "@/auxillary";
import {rules} from "@/auxillary/rules";
import IRoleDto = MdbsCore.IRoleDto;
import IUserUpdateDto = MdbsCore.IUserUpdateDto;
import UserUpdateDto = MdbsCore.UserUpdateDto;
import Rights = MdbsCore.Rights;

@Component({})
export default class UserCreateDialog extends Vue {
  @Prop({required: true})
  user!: IUserUpdateDto;
  @Prop({required: true})
  userDeactivated!: boolean;

  currentUser: IUserUpdateDto = new UserUpdateDto();
  deactivate = false;
  newPassword = "";

  valid = false;
  saving = false;
  rules = rules;

  get allRoles(): IRoleDto[] {
    return rolesModule.roles;
  }

  get rolesLoading() {
    return rolesModule.isLoading;
  }

  get canChangePassword() {
    return currentUserModule.hasRight(Rights.UserPasswordChangeCmd);
  }

  getRoleName(role: IRoleDto) {
    return `${role.displayName} (${role.identifier})`;
  }

  @Watch('user', {immediate: true, deep: true})
  async onUserChanged(user: IUserUpdateDto | null) {
    if (user == null) {
      return;
    }

    this.currentUser = deepCopy(user);
    this.deactivate = this.userDeactivated;
    Vue.nextTick(() => {
      this.form.validate();
    });
    await rolesModule.loadAll();
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean }
  }

  async save() {
    try {
      this.saving = true;
      await usersModule.updateCompleteUser({
        user: this.currentUser,
        deactivate: this.deactivate,
        newPassword: this.newPassword ? this.newPassword : undefined
      });

      this.$emit('save');
    } finally {
      this.saving = false;
      this.newPassword = "";
      this.deactivate = false;
    }
  }

  async cancel() {
    this.$emit('cancel');
  }
}
